export default {
  settings: [],
  maintenance: null,
  whiteBranding: null
}
  